function profiles() {
    const copyText = (value) => {
        if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(value);
        const field = document.createElement('textarea');
        field.value = value;
        field.setAttribute('readonly', '');
        field.style.position = 'fixed';
        field.style.opacity = '0';
        document.body.appendChild(field);
        field.select();
        const copied = document.execCommand('copy');
        field.remove();
        return copied ? Promise.resolve() : Promise.reject(new Error('Copy failed'));
    };

    const temporaryLabel = (button, label) => {
        button.textContent = label;
        window.setTimeout(() => { button.textContent = button.dataset.defaultLabel || 'Copy link'; }, 1800);
    };

    document.querySelectorAll('.toptech-profile-copy').forEach((button) => {
        button.addEventListener('click', () => {
            copyText(button.dataset.copyUrl || window.location.href).then(() => temporaryLabel(button, 'Link copied'));
        });
    });

    document.querySelectorAll('.toptech-profile-share').forEach((button) => {
        button.addEventListener('click', () => {
            const url = button.dataset.shareUrl || window.location.href;
            const title = button.dataset.shareTitle || document.title;
            const share = navigator.share ? navigator.share({title, url}) : copyText(url);
            button.disabled = true;
            Promise.resolve(share).then(() => temporaryLabel(button, navigator.share ? 'Shared' : 'Link copied')).catch(() => {}).finally(() => { button.disabled = false; });
        });
    });

    const bio = document.querySelector('.toptech-profile-form textarea[name="bio"]');
    const bioCount = document.querySelector('[data-profile-bio-count]');
    if (bio && bioCount) bio.addEventListener('input', () => { bioCount.textContent = String(bio.value.length); });

    const profileForm = document.querySelector('.toptech-profile-form');
    const saveHeading = profileForm?.querySelector('.toptech-profile-form__submit strong');
    if (profileForm && saveHeading) {
        const markChanged = () => {
            saveHeading.textContent = 'Unsaved changes';
            profileForm.classList.add('has-unsaved-changes');
        };
        profileForm.addEventListener('input', markChanged);
        profileForm.addEventListener('change', markChanged);
    }

    const publicToggle = profileForm?.querySelector('input[name="is_public"]');
    const statusBadges = Array.from(document.querySelectorAll('[data-profile-status-badge]'));
    const visibilityStatus = document.querySelector('[data-profile-visibility-status]');
    const visibilityLabel = document.querySelector('[data-profile-visibility-label]');
    const visibilityCopy = document.querySelector('[data-profile-visibility-copy]');
    const renderVisibility = () => {
        if (!publicToggle) return;
        const isPublic = publicToggle.checked;
        statusBadges.forEach((badge) => {
            badge.classList.toggle('is-public', isPublic);
            badge.classList.toggle('is-private', !isPublic);
            badge.textContent = isPublic ? badge.dataset.publicLabel : badge.dataset.privateLabel;
        });
        visibilityStatus?.classList.toggle('is-public', isPublic);
        visibilityStatus?.classList.toggle('is-private', !isPublic);
        if (visibilityLabel) visibilityLabel.textContent = isPublic ? 'Public' : 'Private';
        if (visibilityCopy) visibilityCopy.textContent = isPublic
            ? 'Visible to everyone.'
            : 'Only you can view this profile until you publish it.';
    };
    publicToggle?.addEventListener('change', renderVisibility);
    renderVisibility();

    const photo = document.querySelector('[data-profile-photo]');
    if (photo) {
        const fileInput = photo.querySelector('input[type="file"]');
        const image = photo.querySelector('[data-profile-photo-image]');
        const placeholder = photo.querySelector('[data-profile-photo-placeholder]');
        const removeButton = photo.querySelector('[data-profile-photo-remove]');
        const removeValue = photo.querySelector('[data-profile-photo-remove-value]');
        const status = photo.querySelector('[data-profile-photo-status]');
        const chooseLabel = photo.querySelector('.toptech-profile-photo__choose');
        let previewUrl = '';

        const showStatus = (message, isError = false) => {
            if (!status) return;
            status.textContent = message;
            status.classList.toggle('is-error', isError);
        };

        fileInput?.addEventListener('change', () => {
            const file = fileInput.files?.[0];
            if (!file) return;
            const allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];
            const maxSize = Number(fileInput.dataset.maxSize || 5242880);
            if (!allowedTypes.includes(file.type) || file.size > maxSize) {
                fileInput.value = '';
                showStatus('Choose a JPG, PNG, or WebP image smaller than 5 MB.', true);
                return;
            }

            if (previewUrl) URL.revokeObjectURL(previewUrl);
            previewUrl = URL.createObjectURL(file);
            const preview = document.createElement('img');
            preview.src = previewUrl;
            preview.alt = '';
            if (image) {
                image.replaceChildren(preview);
                image.hidden = false;
            }
            if (placeholder) placeholder.hidden = true;
            if (removeValue) removeValue.value = '0';
            if (removeButton) removeButton.hidden = false;
            if (chooseLabel) chooseLabel.textContent = 'Change photo';
            showStatus(file.name);
        });

        removeButton?.addEventListener('click', () => {
            if (previewUrl) URL.revokeObjectURL(previewUrl);
            previewUrl = '';
            if (fileInput) fileInput.value = '';
            if (image) image.hidden = true;
            if (placeholder) placeholder.hidden = false;
            if (removeValue) removeValue.value = '1';
            removeButton.hidden = true;
            if (chooseLabel) chooseLabel.textContent = 'Choose photo';
            showStatus('Photo will be removed when you save.');
            profileForm?.dispatchEvent(new Event('change', {bubbles: true}));
        });
    }

    const picker = document.querySelector('.toptech-profile-tool-picker');
    if (!picker || !window.toptechDirectory) return;

    const input = picker.querySelector('input[type="search"]');
    const results = picker.querySelector('.toptech-profile-tool-picker__results');
    const selected = picker.querySelector('.toptech-profile-tool-picker__selected');
    const status = picker.querySelector('.toptech-profile-tool-picker__status');
    const selectedCount = document.querySelector('[data-profile-selected-count]');
    const maxTools = Number(picker.dataset.maxTools || 24);
    let searchTimer = null;
    let controller = null;

    const selectedIds = () => Array.from(selected.querySelectorAll('[data-tool-id]')).map((item) => Number(item.dataset.toolId));
    const updateSelectedCount = () => {
        if (selectedCount) selectedCount.textContent = `${selectedIds().length}/${maxTools}`;
    };
    const removeTool = (button) => {
        button.closest('[data-tool-id]')?.remove();
        updateSelectedCount();
    };
    selected.addEventListener('click', (event) => {
        const button = event.target.closest('button');
        if (button) removeTool(button);
    });

    const addTool = (tool) => {
        if (selectedIds().includes(Number(tool.id))) {
            status.textContent = 'Already added';
            return;
        }
        if (selectedIds().length >= maxTools) {
            status.textContent = `Choose up to ${maxTools} tools`;
            return;
        }
        const item = document.createElement('span');
        item.className = 'toptech-profile-selected-tool';
        item.dataset.toolId = String(tool.id);
        const hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'tool_ids[]';
        hidden.value = String(tool.id);
        const label = document.createElement('span');
        label.textContent = tool.title;
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.setAttribute('aria-label', `Remove ${tool.title}`);
        remove.textContent = '×';
        item.append(hidden, label, remove);
        selected.appendChild(item);
        updateSelectedCount();
        input.value = '';
        results.hidden = true;
        status.textContent = 'Tool added';
        input.focus();
    };

    const renderResults = (tools) => {
        results.replaceChildren();
        if (!tools.length) {
            results.hidden = true;
            status.textContent = 'No matching tools';
            return;
        }
        tools.forEach((tool) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.setAttribute('role', 'option');
            button.textContent = tool.title;
            button.disabled = selectedIds().includes(Number(tool.id));
            button.addEventListener('click', () => addTool(tool));
            results.appendChild(button);
        });
        results.hidden = false;
        status.textContent = `${tools.length} result${tools.length === 1 ? '' : 's'}`;
    };

    input.addEventListener('input', () => {
        window.clearTimeout(searchTimer);
        const query = input.value.trim();
        if (query.length < 2) {
            results.hidden = true;
            status.textContent = query ? 'Type at least 2 characters' : '';
            return;
        }
        status.textContent = 'Searching…';
        searchTimer = window.setTimeout(() => {
            if (controller) controller.abort();
            controller = new AbortController();
            const url = new URL(window.toptechDirectory.ajaxUrl, window.location.origin);
            url.searchParams.set('action', window.toptechDirectory.profileToolSearchAction);
            url.searchParams.set('nonce', window.toptechDirectory.nonce);
            url.searchParams.set('query', query);
            window.fetch(url, {credentials: 'same-origin', signal: controller.signal}).then((response) => response.json()).then((payload) => {
                if (!payload.success) throw new Error('Search unavailable');
                renderResults(payload.data.tools || []);
            }).catch((error) => {
                if (error.name !== 'AbortError') status.textContent = 'Search unavailable';
            });
        }, 220);
    });

    document.addEventListener('click', (event) => {
        if (!picker.contains(event.target)) results.hidden = true;
    });
}

export {profiles};
